document.addEventListener("DOMContentLoaded", () => {
  /*
   * =========================================================
   * Product Accordion
   * =========================================================
   */

  const initAccordion = (section) => {
    const accordionItems = section.querySelectorAll(".product-accordion-item");

    accordionItems.forEach((item) => {
      const button = item.querySelector(".product-accordion-button");
      const content = item.querySelector(".product-accordion-content");

      if (!button || !content) return;

      button.addEventListener("click", () => {
        const isOpen = item.classList.contains("active");

        accordionItems.forEach((accordionItem) => {
          accordionItem.classList.remove("active");

          const accordionContent = accordionItem.querySelector(
            ".product-accordion-content"
          );

          if (accordionContent) {
            accordionContent.style.maxHeight = null;
          }
        });

        if (!isOpen) {
          item.classList.add("active");
          content.style.maxHeight = `${content.scrollHeight}px`;
        }
      });
    });
  };

  /*
   * =========================================================
   * Product Countdown
   * =========================================================
   */

  let countdownInterval;

  const initProductCountdown = () => {
    const countdownElement = document.querySelector(
      ".product-countdown__timer"
    );

    if (!countdownElement) return;

    const endDate = countdownElement.dataset.endDate;

    if (!endDate) return;

    clearInterval(countdownInterval);

    const updateCountdown = () => {
      const now = new Date().getTime();
      const end = new Date(endDate).getTime();
      const distance = end - now;

      if (distance <= 0) {
        countdownElement.innerHTML = "";
        clearInterval(countdownInterval);
        return;
      }

      const days = Math.floor(distance / (1000 * 60 * 60 * 24));
      const hours = Math.floor(
        (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
      );
      const minutes = Math.floor(
        (distance % (1000 * 60 * 60)) / (1000 * 60)
      );
      const seconds = Math.floor((distance % (1000 * 60)) / 1000);

      const daysElement = countdownElement.querySelector(
        "[data-countdown-days]"
      );
      const hoursElement = countdownElement.querySelector(
        "[data-countdown-hours]"
      );
      const minutesElement = countdownElement.querySelector(
        "[data-countdown-minutes]"
      );
      const secondsElement = countdownElement.querySelector(
        "[data-countdown-seconds]"
      );

      if (daysElement) {
        daysElement.textContent = String(days).padStart(2, "0");
      }

      if (hoursElement) {
        hoursElement.textContent = String(hours).padStart(2, "0");
      }

      if (minutesElement) {
        minutesElement.textContent = String(minutes).padStart(2, "0");
      }

      if (secondsElement) {
        secondsElement.textContent = String(seconds).padStart(2, "0");
      }
    };

    updateCountdown();
    countdownInterval = setInterval(updateCountdown, 1000);
  };

  const removeProductCountdown = () => {
    clearInterval(countdownInterval);
  };

  /*
   * =========================================================
   * Sticky Product Bar
   * =========================================================
   */

  const revealPopup = (section) => {
    if (!section) return;

    const buyButtons = section.querySelector(
      ".product__buy-buttons > product-form"
    );

    const stickyBar = document.querySelector(".product-countdown");

    const footerBottom = document.querySelector(
      ".shopify-section-group-footer-group .footer-bottom"
    );

    if (!buyButtons || !stickyBar) return;

    /*
     * Change this value to control how early the sticky bar
     * appears.
     *
     * 300 = sticky bar appears when the main Add to Cart
     * section is 300px away from the top of the viewport.
     */
    const STICKY_TRIGGER_OFFSET = 80;

    let ticking = false;

    const updateStickyBar = () => {
      if (ticking) return;

      ticking = true;

      window.requestAnimationFrame(() => {
        const buyButtonsRect = buyButtons.getBoundingClientRect();

        /*
         * Check whether the footer is visible.
         * We hide the sticky bar when the footer starts
         * entering the viewport.
         */
        let footerVisible = false;

        if (footerBottom) {
          const footerRect = footerBottom.getBoundingClientRect();

          footerVisible =
            footerRect.top < window.innerHeight &&
            footerRect.bottom > 0;
        }

        /*
         * Sticky bar appears earlier:
         *
         * Original:
         * buyButtonsRect.top <= 0
         *
         * Updated:
         * buyButtonsRect.top <= STICKY_TRIGGER_OFFSET
         */
        const shouldShowStickyBar =
          buyButtonsRect.top <= STICKY_TRIGGER_OFFSET;

        if (shouldShowStickyBar && !footerVisible) {
          stickyBar.classList.add("active");
          initProductCountdown();
        } else {
          stickyBar.classList.remove("active");
          removeProductCountdown();
        }

        ticking = false;
      });
    };

    /*
     * Initial check
     */
    updateStickyBar();

    /*
     * Check while scrolling
     */
    window.addEventListener("scroll", updateStickyBar, {
      passive: true,
    });

    /*
     * Check when browser window is resized
     */
    window.addEventListener("resize", updateStickyBar);

    /*
     * Check when Shopify dynamically changes the section
     */
    document.addEventListener("shopify:section:load", updateStickyBar);
  };

  /*
   * =========================================================
   * Initialize Product Sections
   * =========================================================
   */

  document.querySelectorAll(".shopify-section").forEach((section) => {
    initAccordion(section);
  });

  /*
   * =========================================================
   * Shopify Section Load
   * =========================================================
   */

  document.addEventListener("shopify:section:load", (event) => {
    const section = event.target;

    initAccordion(section);
    revealPopup(section);
  });

  /*
   * =========================================================
   * Initialize Current Product Section
   * =========================================================
   */

  document.querySelectorAll(".shopify-section").forEach((section) => {
    if (section.querySelector(".product__buy-buttons")) {
      revealPopup(section);
    }
  });

  /*
   * =========================================================
   * Sticky Add To Cart / Buy Button
   * =========================================================
   */

  document.addEventListener("click", (event) => {
    const buyButton = event.target.closest(".product-form__buy");

    if (!buyButton) return;

    const form = buyButton.closest("form");

    if (!form) return;

    /*
     * Keep the existing Shopify form behaviour unless
     * the button is specifically configured for the
     * custom checkout behaviour.
     */
    if (buyButton.dataset.checkout === "true") {
      event.preventDefault();

      const formData = new FormData(form);

      fetch("/cart/add.js", {
        method: "POST",
        headers: {
          Accept: "application/json",
        },
        body: formData,
      })
        .then((response) => {
          if (!response.ok) {
            throw new Error("Unable to add product to cart.");
          }

          return response.json();
        })
        .then(() => {
          window.location.href = "/checkout";
        })
        .catch((error) => {
          console.error(error);
        });
    }
  });
});